import { Injectable } from '@angular/core';
import { Locale } from '@finxone-platform/shared/enums';
import { AlertResponse } from '@finxone-platform/shared/sys-config-types';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { catchError, map, of } from 'rxjs';
import {
  AddProgressBarWorkflowStack,
  RemoveProgressBarWorkflowStack,
} from '../actions/progress-bar-workflow.action';
import { GetProjectNotifications } from '../actions/project-notifications.action';
import { ApiService } from '../services/api-service/api.service';

//Later need to update with inApp, sms and email
export interface ProjectNotificationsStateModel {
  push: AlertResponse;
}

@State<ProjectNotificationsStateModel>({
  name: 'ProjectNotificationsState',
  defaults: {
    push: {} as AlertResponse,
  },
})
@Injectable()
export class ProjectNotificationsState {
  constructor(private apiService: ApiService) {}

  @Selector()
  static getProjectNotificationsState(state: ProjectNotificationsStateModel) {
    return state;
  }

  @Selector()
  static getProjectPushNotificationsFromState(state: ProjectNotificationsStateModel) {
    return state.push;
  }

  @Action(GetProjectNotifications)
  fetchProjectNotifications(
    ctx: StateContext<ProjectNotificationsStateModel>,
    action: GetProjectNotifications,
  ) {
    if (action.projectId && action.params?.key) {
      ctx.dispatch(new AddProgressBarWorkflowStack({ uniqueId: 'GetProjectNotifications' }));

      return this.apiService
        .getCall<AlertResponse>(`/project-alerts/toaster/${action.projectId}`, {
          params: action.params,
        })
        .pipe(
          map((res) => {
            if (res) {
              if (Object.keys(res.value)?.length) {
                ctx.patchState({
                  ...ctx.getState(),
                  push: res,
                });
              } else {
                res.value = {};
                ctx.patchState({
                  ...ctx.getState(),
                  push: res,
                });
              }
            } else {
              const alerts = {};
              ctx.patchState({
                ...ctx.getState(),
                push: {
                  key: 'push',
                  locale: Locale.en_GB,
                  value: alerts,
                  isDefault: true,
                },
              });
            }
            ctx.dispatch(
              new RemoveProgressBarWorkflowStack({
                uniqueId: 'GetProjectNotifications',
              }),
            );
          }),
          catchError((err) => {
            console.error('Error fetching project alerts config', err);
            ctx.dispatch(
              new RemoveProgressBarWorkflowStack({
                uniqueId: 'GetProjectNotifications',
              }),
            );
            throw err;
          }),
        )
        .subscribe();
    } else {
      return of(null);
    }
  }
}
